import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getCompanyDocumentListData } from './mockData'
import type { ICompanyDocument } from '~/types/document/models'

export const {
  getDocuments: getCompanyDocuments,
  postDocument: postCompanyDocument,
  patchDocument: patchCompanyDocument,
  deleteDocument: deleteCompanyDocument,
  handlers,
} = makeDocumentAPIs<ICompanyDocument>({
  apiPathEntityNamePrefix: 'company',
  getDocumentListDataFn: getCompanyDocumentListData,
})
